module.exports = __webpack_public_path__ + "static/media/File.a40e44d8.svg";